// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getNotificationsEpic } from './getNotificationsEpic';
import { readAllNotificationsEpic } from './readAllNotificationsEpic';
import { readNotificationEpic } from './readNotificationEpic';
import { deleteNotificationsEpic } from './deleteNotificationsEpic';
import { getResetNotificationsEpic } from './getResetNotificationsEpic';

export default [
  getNotificationsEpic,
  readAllNotificationsEpic,
  readNotificationEpic,
  deleteNotificationsEpic,
  getResetNotificationsEpic
]
